import { CommonModule } from "@angular/common";
import { Component, Input, ViewEncapsulation } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CheckboxModule } from "primeng/checkbox";

@Component({
  selector: "app-order-setup-plan",
  standalone: true,
  imports: [CheckboxModule, CommonModule, FormsModule],
  templateUrl: "./setup-plan.component.html",
  styleUrl: "./setup-plan.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class OrderSetupPlanComponent {
  termsAccepted: boolean = false;
  @Input() activateCallback!: (step: number) => void;
    goToPrevStep(data:number) {
    if (this.activateCallback) {
      this.activateCallback(data); // Example usage of the function
    }
  }
}
